import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import AllServices from "../../../AllServices";

import { headerHeight, submenuHeight } from "../../../../consts";

import styles from "./BottomAllServicesDropdown.scss";

const cx = classnames.bind(styles);

const BottomAllServicesDropdown = ({ className, isSubmenuVisible }) => {
  const [topMargin, setTopMargin] = useState(0);

  useEffect(() => {
    const defaultMargin = 16;

    let offset = headerHeight + defaultMargin;

    if (window) {
      if (headerHeight - window.pageYOffset <= 0) {
        offset = defaultMargin;
      } else {
        offset = headerHeight - window.pageYOffset + defaultMargin;
      }

      if (isSubmenuVisible) {
        offset += submenuHeight;
      }
    }

    setTopMargin(offset);
  }, []);

  return (
    <div className={cx("dropdown", className)}>
      <div style={{ marginTop: topMargin }} className={cx("dropdown-content")}>
        <AllServices isMobile />
      </div>
    </div>
  );
};

BottomAllServicesDropdown.propTypes = {
  className: PropTypes.string,
  isSubmenuVisible: PropTypes.bool,
};

export default BottomAllServicesDropdown;
